import { LeftOutlined } from "@ant-design/icons";
import { useState } from "react";
import { useSideBarStore } from "../../../store/SideBarStore";
import { useInfoUser } from "../../../store/UserStore";
import { Directory } from "./directory/Directory";
import { DirectoryProvider } from "./directory/DirectoryContext";

const OrgManagement = () => {
  const { languageMap } = useInfoUser();

  const [orgList, setOrgList] = useState([]);
  const { switchIsWorkManagementOptions, isWorkManagementOptions } =
    useSideBarStore((state) => state);

  return (
    <div>
      <div className="font-semibold text-[20px] pl-[16px] pt-[16px] flex items-center">
        {!isWorkManagementOptions && (
          <a
            className="btn-back-to-work-management mr-2"
            onClick={switchIsWorkManagementOptions}
          >
            <LeftOutlined size={25} />
          </a>
        )}
        {languageMap?.["as.menu.organization.title"] ?? "Organization"}
      </div>
      <DirectoryProvider
        orgList={orgList}
        setOrgList={setOrgList}
        isOpen={true}
      >
        <Directory />
      </DirectoryProvider>
    </div>
  );
};

export { OrgManagement };
